export const getTimeRange = (date) => {
  if (!date) return null;
  return date.getHours() >= 12 ? 'pm' : 'am';
};

export const isSameDay = (date1, date2) => {
  if (!date1 || !(date1 instanceof Date) || !date2 || !(date2 instanceof Date)) return false;

  return (
    date1.getFullYear() === date2.getFullYear()
    && date1.getMonth() === date2.getMonth()
    && date1.getDate() === date2.getDate()
  );
};

export const range = (start = 0, end) => {
  const length = end - start + 1;
  return Array.from({ length }, (_, i) => start + i);
};



// WEBPACK FOOTER //
// ./components/core/DateTimePicker2/utils.js